<template>
  <div id="messages-filter">
    <div v-if="isSmartphoneOS">
      <f7-navbar v-if="showListGroupPanel()">
        <b-row no-gutters style="text-align:center;width:100%;">
          <b-col>
            <f7-button round class="statusButton"
              :class='mode === 1 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(1)">
              {{ $t('filter.tab_unit') }}
            </f7-button>
          </b-col>
          <b-col>
            <f7-button round class="statusButton"
              :class='mode === 2 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(2)">
              {{ $t('filter.tab_group') }}
            </f7-button>
          </b-col>
        </b-row>
      </f7-navbar>
    </div>
    <f7-list accordion v-else id="directPayments-filter">
      <!-- TLV 15/01/2021 - showing filter title only if there is only one tab
          If there are multiple tabs in the filter (case of supplier service),
            the tabs are stored in the parent component -->
      <f7-list-item class="filterTitle"
        :title="listTitle" id="filter-item" v-if="aloneTab">
        <i class="icon fa fa-filtershowSmallScreenOnly mousePointer"
          @click="$bus.emit('right-panel-open', serviceId)" slot="content">
        </i>
        <div style="display:flex;width:300px;" v-if="showListDraftPanel()">
          <f7-button round class="statusButton"
            :class='modeFilter === 1 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(1)">
            {{ $t('filter.tab_sent') }}
          </f7-button>
          <f7-button round class="statusButton"
            :class='modeFilter === 0 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(0)">
            {{ $t('filter.tab_draft') }}
          </f7-button>
        </div>
        <div style="display:flex;width:300px;" v-else-if="showListGroupPanel()">
          <f7-button round class="statusButton"
            :class='modeFilter === 1 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(1)">
            {{ $t('filter.tab_unit') }}
          </f7-button>
          <f7-button round class="statusButton"
            :class='modeFilter === 2 ? "navbar-button-selected": "navbar-button"'
            @click="applyFilter(2)">
            {{ $t('filter.tab_group') }}
          </f7-button>
        </div>
      </f7-list-item>
    </f7-list>

    <f7-list>
      <!-- Boutons de sélection/sauvegarde/suppression/application du filtre -->
      <f7-list-item :class="additionalClass" :style="buttonsListStyle">
        <b-row style="min-width:100%;">
          <b-col cols="4" class="d-flex flex-row showLargeScreenOnly">
            <f7-button round class="statusButton searchFilterButton"
              @click="displayFilter = !displayFilter">
              {{ displayFilter ? $t('filter.hide_fltr') : $t('filter.slct_fltr') }}
            </f7-button>
          </b-col>

          <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
          <b-col cols="12" class="showSmallScreenOnly">
            <f7-button round class="statusButton searchFilterButton"
              @click="$bus.emit('right-panel-open', serviceId)">
              {{ $t('filter.slct_fltr') }}
            </f7-button>
          </b-col>

          <b-col cols="5" class="d-flex flex-row-reverse showLargeScreenOnly" v-if="displayFilter">
            <!-- Attention : les boutons s'affichent de droite à gauche -->
            <f7-button round class="statusButton searchFilterButton"
              :disabled="!hasDefaultFilter"
              @click="deleteFilter">
              {{ $t('filter.cln_fltr') }}
            </f7-button>
            <f7-button round class="statusButton searchFilterButton"
              :disabled="!hasInputFilter"
              @click="saveDefaultFilter">
              {{ $t('filter.sv_fltr') }}
            </f7-button>
          </b-col>
        </b-row>
      </f7-list-item>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}"
        class="showLargeScreenOnly" style="border: 1px solid #aaa;">
        <b-row style="min-width:100%;">
          <b-col class="d-flex flex-row">

            <!-- Filtre d'id du fournisseur (qui s'affiche si la raison sociale est affichée)-->
            <div class="filter-item" v-if="showFilterSupplierId() && LMSGsupplierconfig">
              <span class="filter-item-title">
                {{ $t('filter.supplier_id') }}
              </span>
              <span class="filter-item-content">
                <textarea v-model="filterSupplierId"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierId}"
                  :placeholder="$t('filter.supplier_id')">
                </textarea>
              </span>
            </div>

            <!-- Filtre SIREN du fournisseur -->
            <div class="filter-item" v-if="showFilterSupplierSIREN()">
              <span class="filter-item-title">
                {{ $t('common.srn') }}
              </span>
              <span class="filter-item-content">
                <textarea v-model="filterSiren"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSiren}"
                  :placeholder="$t('common.srn_placeholder_supplier')">
                </textarea>
              </span>
            </div>

            <!-- Filtre raison sociale du fournisseur -->
            <div class="filter-item" v-if="showFilterSupplierName()">
              <span class="filter-item-title">{{ $t('common.social_reason') }}</span>
              <span class="filter-item-content">
                <textarea v-model="filterSupplierName"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierName}"
                  :placeholder="$t('filter.social_reason_placeholder')">
                </textarea>
              </span>
            </div>

            <!-- Type du document -->
            <div class="filter-item" v-if="showFilterDoctype()">
              <span class="filter-item-title">{{ 'Type du document' }}</span>
              <span class="filter-item-content d-flex">
                <select ref="selectDoctype"
                  v-model="filterDocumentType"
                  style="cursor:pointer;font-size:14px;height:auto;z-index:2;">
                  <option value=""></option>
                  <option value="IDCARD">Carte d'identité</option>
                  <option value="RIB">RIB</option>
                  <option value="Kbis">Kbis</option>
                </select>
                <f7-icon f7="chevron_down" id="status-chevron"
                  style="cursor:pointer;margin-left:-20px;z-index:1;">
                </f7-icon>
              </span>
            </div>

            <!-- Nom du document -->
            <div class="filter-item" v-if="showFilterDocname()">
              <span class="filter-item-title">{{ 'Nom du document' }}</span>
              <span class="filter-item-content d-flex">
                <textarea v-model="filterDocumentName"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterDocumentName}"
                  :placeholder="$t('common.name_placeholder')">
                </textarea>
              </span>
            </div>

            <!-- Filtre statut -->
            <div class="filter-item" v-if="showFilterStatus()">
              <span class="filter-item-title">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
              </span>
              <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content"
                href="#">
                <f7-icon v-if="statusDisplay.icon" :class="statusDisplay.icon"></f7-icon>
                <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
                <f7-icon f7="chevron_down" id="status-chevron"></f7-icon>
              </a>
              <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_status_none')"
                triggers="focus" placement="bottomright">
                <span v-for="status in statusList" :key="status.name">
                  <b-form-checkbox v-model="status.state"
                    v-if="showStatus(status)"
                    :value="1"
                    :unchecked-value="0">
                    <f7-icon :icon="status.icon"></f7-icon>
                    <span>{{ status.label }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <!-- Filtre date de début -->
            <div class="filter-item" v-if="showFilterDateBegin()">
              <span class="filter-item-title">
                {{ $t('common.date_start_label') }}</span>
              <span class="filter-item-content">
                <input v-model="dateBegin"
                  type="date"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
                  :placeholder="$t('common.slct_date')">
                </input>
              </span>
            </div>

            <!-- Filtre date de fin -->
            <div class="filter-item" v-if="showFilterDateEnd()">
              <span class="filter-item-title">
                {{ $t('common.date_end_label') }}
              </span>
              <span class="filter-item-content">
                <input v-model="dateEnd"
                  type="date"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
                  :placeholder="$t('common.slct_date')">
                </input>
              </span>
            </div>

            <!-- Filtre raison -->
            <div class="filter-item" v-if="showFilterReason()">
              <span class="filter-item-title">{{ $t('filter.reason') }}</span>
              <span class="filter-item-content">
                <textarea v-model="reason"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': reason}"
                  :placeholder="$t('filter.reason_placeholder')">
                </textarea>
              </span>
            </div>

            <!-- Filtre contact -->
            <div class="filter-item" v-if="showFilterContactName()">
              <span class="filter-item-title">{{ $t('filter.cntct_name') }}</span>
              <span class="filter-item-content">
                <textarea v-model="cdtrOrDbtrNm"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': cdtrOrDbtrNm}"
                  :placeholder="$t('filter.cntct_name_placeholder')">
                </textarea>
              </span>
            </div>

            <!-- Filtre type d'action -->
            <div class="filter-item" v-if="showFilterTypeAction()">
              <span class="filter-item-title">{{ $t('filter.action_type') }}</span>
              <span class="filter-item-content d-flex">
                <select ref="selectTypeAction"
                  v-model="typeAction"
                  style="cursor:pointer;font-size:14px;height:auto;z-index:2;">
                  <option value="">{{ $t('filter.action_type_choose') }}</option>
                  <option value="CREATE">{{ $t('history.CREATE') }}</option>
                  <option value="DELETE">{{ $t('history.DELETE') }}</option>
                  <option value="MODIFY">{{ $t('history.MODIFY') }}</option>
                  <option value="SEND">{{ $t('history.SEND') }}</option>
                  <option value="CANCEL">{{ $t('history.CANCEL') }}</option>
                  <option value="ACCEPT">{{ $t('history.ACCEPT') }}</option>
                  <option value="REFUSE">{{ $t('history.REFUSE') }}</option>
                  <option value="MODIFY_AND_ACCEPT">{{ $t('history.MODIFY_AND_ACCEPT') }}</option>
                  <option value="ACCEPT_AND_PAY">{{ $t('history.ACCEPT_AND_PAY') }}</option>
                  <option value="PAY">{{ $t('history.PAY') }}</option>
                  <option value="SAVE">{{ $t('history.SAVE') }}</option>
                  <option value="UPLOAD">{{ $t('history.UPLOAD') }}</option>
                  <option value="UPLOAD_API">{{ $t('history.UPLOAD_API') }}</option>
                </select>
                <f7-icon f7="chevron_down" id="status-chevron"
                  style="cursor:pointer;margin-left:-20px;z-index:1;">
                </f7-icon>
              </span>
            </div>

            <!-- Filtre endToEndId -->
            <div class="filter-item" v-if="showFilterEndToEndId()">
              <span class="filter-item-title">{{ 'Identifiant' }}</span>
              <span class="filter-item-content">
                <textarea v-model="endToEndId"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': endToEndId}"
                  :placeholder="'Identifiant'">
                </textarea>
              </span>
            </div>

            <!-- Filtre user -->
            <div class="filter-item" v-if="showFilterUser()">
              <span class="filter-item-title">{{ 'Utilisateur' }}</span>
              <span class="filter-item-content">
                <textarea v-model="user"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                  :placeholder="'Saisir l\'identifiant'">
                </textarea>
              </span>
            </div>
          </b-col>

          <!-- Bouton Effacer et Appliquer -->
          <b-col cols="3" class="d-flex flex-row-reverse" style="margin-top: 10px;">
            <f7-button round class="statusButton searchFilterButton"
              @click="applyFilter(modeFilter)">
              {{ $t('filter.appl_fltr') }}
            </f7-button>
            <f7-button round class="statusButton searchFilterButton"
              @click="clearFilterFields"
              style="max-width: fit-content" :disabled="!hasInputFilter">
              {{ $t('filter.clr_fltr_field') }}
            </f7-button>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import datePickerMixin from '@/mixins/datePickerMixin'
import Status from '@/helpers/status.js'
import {statusLabel, statusIcon} from '@/helpers/labels.js'
import services from '@/helpers/services.js'

export default {
  mixins: [datePickerMixin],
  name: 'MessagesFilter',
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    aloneTab: {
      type: Boolean,
      default: true
    },
    filterType: {
      type: String,
      default: 'list'
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    isPayments: {
      type: Boolean,
      default: true
    },
    isOcr: {
      type: Boolean,
      default: false
    },
    isVerifications: {
      type: Boolean,
      default: false
    },
    listMainTitle: {
      type: String,
      default: ''
    },
    mode: {
      type: Number,
      default: 1
    },
    propedServiceId: {
      type: String,
      default: 'none'
    },
    randomId: {
      type: String,
      default: ''
    },
    received: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      dir: 0,
      displayFilter: false,
      hasDefaultFilter: false,
      dateBegin: '',
      dateEnd: '',
      cdtrOrDbtrNm: '',
      endToEndId: '',
      reason: '',
      typeAction: '',
      user: '',
      filterDocumentName: '',
      filterDocumentType: '',
      filterSiren: '',
      filterSupplierName: '',
      filterSupplierId: '',
      filterTypeGet: 'list',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      modeFilter: this.mode,
      services: services,
      statusList: {
        statusWaiting: {
          label: statusLabel(this.$i18n, Status.WAITING),
          icon: statusIcon(Status.WAITING),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusExpired: {
          label: statusLabel(this.$i18n, Status.EXPIRED),
          icon: statusIcon(Status.EXPIRED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        // statusNegotiationRequest: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '10'),
        //   icon: statusIcon(Status.WAITING, '10'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        // statusNegotiationResponse: {
        //   label: statusLabel(this.$i18n, Status.WAITING, '11'),
        //   icon: statusIcon(Status.WAITING, '11'),
        //   state: 0,
        //   filterName: 'list',
        //   services: ['1']
        // },
        statusRequestReceived: {
          label: statusLabel(this.$i18n, Status.RECEIVED),
          icon: statusIcon(Status.RECEIVED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestAccepted: {
          label: statusLabel(this.$i18n, Status.ACCEPTED),
          icon: statusIcon(Status.ACCEPTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestRevoked: {
          label: statusLabel(this.$i18n, Status.REVOKED),
          icon: statusIcon(Status.REVOKED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestModified: {
          label: statusLabel(this.$i18n, Status.MODIFIED),
          icon: statusIcon(Status.MODIFIED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusAcceptedAndPayed: {
          label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED),
          icon: statusIcon(Status.ACCEPTED_AND_PAYED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusAcceptedAndPayedInstant: {
          label: statusLabel(this.$i18n, Status.ACCEPTED_AND_PAYED_INST),
          icon: statusIcon(Status.ACCEPTED_AND_PAYED_INST),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusModifiedAndPayed: {
          label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED),
          icon: statusIcon(Status.MODIFIED_AND_PAYED),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusModifiedAndPayedInstant: {
          label: statusLabel(this.$i18n, Status.MODIFIED_AND_PAYED_INST),
          icon: statusIcon(Status.MODIFIED_AND_PAYED_INST),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCreditTransferGenerated: {
          label: statusLabel(this.$i18n, Status.ORDER_GENERATED),
          icon: statusIcon(Status.ORDER_GENERATED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCreditTransferGeneratedInstant: {
          label: statusLabel(this.$i18n, Status.INST_ORDER_GENERATED),
          icon: statusIcon(Status.INST_ORDER_GENERATED),
          state: 0,
          filterName: 'list',
          services: ['1', '6']
        },
        statusBankStatementReceived: {
          label: statusLabel(this.$i18n, Status.MADE),
          icon: statusIcon(Status.MADE),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusBankStatementReceivedInstant: {
          label: statusLabel(this.$i18n, Status.INST_MADE),
          icon: statusIcon(Status.INST_MADE),
          state: 0,
          filterName: 'list',
          services: ['1', '6']
        },
        statusInstallmentPaid: {
          label: statusLabel(this.$i18n, Status.INSTALLMENT_PAID),
          icon: statusIcon(Status.INSTALLMENT_PAID),
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCanceled: {
          label: statusLabel(this.$i18n, Status.CANCELED),
          icon: statusIcon(Status.CANCELED),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCanceledConfirm: {
          label: statusLabel(this.$i18n, Status.CANCELED_CONFIRM),
          icon: statusIcon(Status.CANCELED_CONFIRM),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusCanceledReject: {
          label: statusLabel(this.$i18n, Status.CANCELED_ABORT),
          icon: statusIcon(Status.CANCELED_ABORT),
          state: 0,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRejected: {
          label: statusLabel(this.$i18n, Status.REJECTED),
          icon: statusIcon(Status.REJECTED),
          state: 0,
          filterName: 'list',
          services: ['1', '2']
        },
        statusInformation: {
          label: statusLabel(this.$i18n, Status.INFORMATION),
          icon: statusIcon(Status.INFORMATION),
          state: 0,
          filterName: 'list',
          services: ['6']
        },
        statusNotClosedFolder: {
          label: statusLabel(this.$i18n, Status.NOT_CLOSED_FOLDER),
          icon: statusIcon(Status.NOT_CLOSED_FOLDER),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusClosedFolder: {
          label: statusLabel(this.$i18n, Status.CLOSED_FOLDER),
          icon: statusIcon(Status.CLOSED_FOLDER),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusFolderContainingExpired: {
          label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_EXPIRED),
          icon: statusIcon(Status.FOLDER_CONTAINING_EXPIRED),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusFolderContainingRefused: {
          label: statusLabel(this.$i18n, Status.FOLDER_CONTAINING_REFUSED),
          icon: statusIcon(Status.FOLDER_CONTAINING_REFUSED),
          state: 0,
          filterName: 'list',
          services: ['7']
        },
        statusDocInitialized: {
          label: statusLabel(this.$i18n, Status.DOC_INITIALIZED),
          icon: statusIcon(Status.DOC_INITIALIZED),
          state: 0,
          filterName: 'details',
          services: ['8']
        },
        statusKYCwaiting: {
          label: statusLabel(this.$i18n, Status.PROVIDER_OPEN),
          icon: statusIcon(Status.PROVIDER_OPEN),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCvalidated: {
          label: statusLabel(this.$i18n, Status.PROVIDER_VALIDATED),
          icon: statusIcon(Status.PROVIDER_VALIDATED),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCrefused: {
          label: statusLabel(this.$i18n, Status.PROVIDER_NOT_VALIDATED),
          icon: statusIcon(Status.PROVIDER_NOT_VALIDATED),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCtorefresh: {
          label: statusLabel(this.$i18n, Status.PROVIDER_TO_REFRESH),
          icon: statusIcon(Status.PROVIDER_TO_REFRESH),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusKYCclosed: {
          label: statusLabel(this.$i18n, Status.PROVIDER_CLOSED),
          icon: statusIcon(Status.PROVIDER_CLOSED),
          state: 0,
          filterName: 'list',
          services: ['8']
        },
        statusRequestSent: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_SENT),
          icon: statusIcon(Status.DOC_REQUEST_SENT),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestReceived: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_RECEIVED),
          icon: statusIcon(Status.DOC_REQUEST_RECEIVED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestRejected: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_REJECTED),
          icon: statusIcon(Status.DOC_REQUEST_REJECTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestCanceled: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_CANCELED),
          icon: statusIcon(Status.DOC_REQUEST_CANCELED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestOutTime: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_OUT_TIME),
          icon: statusIcon(Status.DOC_REQUEST_OUT_TIME),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestAccepted: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_ACCEPTED),
          icon: statusIcon(Status.DOC_REQUEST_ACCEPTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRequestRefused: {
          label: statusLabel(this.$i18n, Status.DOC_REQUEST_REFUSED),
          icon: statusIcon(Status.DOC_REQUEST_REFUSED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocSent: {
          label: statusLabel(this.$i18n, Status.DOC_SENT),
          icon: statusIcon(Status.DOC_SENT),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocReceived: {
          label: statusLabel(this.$i18n, Status.DOC_RECEIVED),
          icon: statusIcon(Status.DOC_RECEIVED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRejected: {
          label: statusLabel(this.$i18n, Status.DOC_REJECTED),
          icon: statusIcon(Status.DOC_REJECTED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocValidated: {
          label: statusLabel(this.$i18n, Status.DOC_VALIDATED),
          icon: statusIcon(Status.DOC_VALIDATED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocRefused: {
          label: statusLabel(this.$i18n, Status.DOC_REFUSED),
          icon: statusIcon(Status.DOC_REFUSED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDocExpired: {
          label: statusLabel(this.$i18n, Status.DOC_EXPIRED),
          icon: statusIcon(Status.DOC_EXPIRED),
          state: 0,
          filterName: 'details',
          services: ['7', '8']
        },
        statusDraftNeedCompleted: {
          label: statusLabel(this.$i18n, Status.DRAFT_NEED_COMPLETED),
          icon: statusIcon(Status.DRAFT_NEED_COMPLETED),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftWaitingValidation: {
          label: statusLabel(this.$i18n, Status.DRAFT_WAITING_VALIDATION),
          icon: statusIcon(Status.DRAFT_WAITING_VALIDATION),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftWaitingUpperValidation: {
          label: statusLabel(this.$i18n, Status.DRAFT_WAITING_UPPER_VALIDATION),
          icon: statusIcon(Status.DRAFT_WAITING_UPPER_VALIDATION),
          state: 0,
          filterName: 'draft',
          services: ['6']
        },
        statusDraftReadyToSend: {
          label: statusLabel(this.$i18n, Status.DRAFT_READY_TO_SEND),
          icon: statusIcon(Status.DRAFT_READY_TO_SEND),
          state: 0,
          filterName: 'draft',
          services: ['6']
        }
      },
      randomString: '',
      serviceId: ''
    }
  },
  created () {
    if (this.propedServiceId === 'none') {
      this.serviceId = this.$engine.user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-save-filter', () => {
      this.saveDefaultFilter()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-delete-filter', () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on('filter-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted () {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case 'details':
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case 'draft':
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case 'group':
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case 'list':
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy () {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off('service:change')
    this.$bus.off('filter-update-fields')
    this.$bus.off('filter-apply-filter-' + this.randomId)
    this.$bus.off('filter-save-filter')
    this.$bus.off('filter-delete-filter')
    this.$bus.off('filter-update-fields')
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          label: status.label,
          icon: status.icon,
          state: status.state
        })
      }
      return list
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(status => status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_status_many'),
          nb: realStatusList.length
        }
      }
    },
    hasInputFilter () {
      if ((this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
        this.dateBegin ||
        this.dateEnd ||
        this.cdtrOrDbtrNm ||
        this.endToEndId ||
        this.reason ||
        this.typeAction ||
        this.user ||
        this.filterDocumentType ||
        this.filterSiren ||
        this.filterSupplierName ||
        this.filterSupplierId) {
        return true
      }
      return false
    },
    listTitle () {
      let fromServiceIdToLabel = {
        0: {
          '6': this.$t('Webheader.my_drafts')
        },
        1: {
          '1': this.$t('Webheader.my_claims'),
          '2': this.$t('Webheader.my_modular_loans'),
          '6': this.$t('Webheader.my_transfers'),
          '7': this.$t('Webheader.my_business_folders'),
          '8': this.$t('Webheader.my_suppliers')
        },
        2: {
          '1': this.$t('Webheader.my_claims_folders'),
          '7': this.$t('Webheader.my_business_documents_to_validate')
        }
      }
      if (this.isHistory) {
        return this.$t('Webheader.history')
      } else if (this.isVerifications) {
        return this.$t('Webheader.my_verifications')
      } else if (this.isOcr) {
        return this.$t('Webheader.my_ocr_scan_doc')
      }
      if (this.listMainTitle === '') {
        return fromServiceIdToLabel[this.modeFilter][this.$engine.user.currentService.id]
      }
      return this.listMainTitle
    },
    filterFields () {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.dateBegin = this.dateBegin
      filter.dateEnd = this.dateEnd
      filter.cdtrOrDbtrNm = this.cdtrOrDbtrNm
      filter.endToEndId = this.endToEndId
      filter.reason = this.reason
      filter.typeAction = this.typeAction
      filter.user = this.user
      filter.filterDocumentType = this.filterDocumentType
      filter.filterSiren = this.filterSiren
      filter.filterSupplierName = this.filterSupplierName
      filter.filterSupplierId = this.filterSupplierId
      filter.hasDefaultFilter = this.hasDefaultFilter

      // Status values
      for (let property in this.statusList) {
        let status = that.statusList[property]
        filter[property] = status.state
      }

      return filter
    }
  },
  methods: {
    applyFilter (mode = 1, filterConditions = {}) {
      let that = this

      if (this.modeFilter !== mode) {
        this.clearFilterFields()
        this.modeFilter = mode
        switch (this.modeFilter) {
          case 0:
            this.filterTypeGet = 'draft'
            break
          case 1:
            this.filterTypeGet = 'list'
            break
          case 2:
            this.filterTypeGet = 'group'
            break
          default:
            this.filterTypeGet = 'list'
            break
        }
        let actualService = this.getActualService()
        var defaultFilter = {}
        switch (this.filterTypeGet) {
          case 'details':
            defaultFilter = actualService.filterDetails.getDefaultFilter()
            break
          case 'draft':
            defaultFilter = actualService.filterDraft.getDefaultFilter()
            break
          case 'group':
            defaultFilter = actualService.filterGroup.getDefaultFilter()
            break
          case 'list':
            defaultFilter = actualService.filter.getDefaultFilter()
            break
          default:
            defaultFilter = actualService.filter.getDefaultFilter()
            break
        }
        // Set default filter values
        this.setDefaultFilter(defaultFilter)
      }

      let actualService = this.getActualService()
      let actualFilter
      switch (this.filterTypeGet) {
        case 'details':
          actualFilter = actualService.filterDetails
          break
        case 'draft':
          actualFilter = actualService.filterDraft
          break
        case 'group':
          actualFilter = actualService.filterGroup
          break
        case 'list':
          actualFilter = actualService.filter
          break
        default:
          actualFilter = actualService.filter
          break
      }
      actualFilter.cleanFilterCondition()

      for (let property in this.statusList) {
        let status = that.statusList[property]
        actualFilter[property] = status.state
      }

      actualFilter.dateBegin = this.dateBegin
      actualFilter.dateEnd = this.dateEnd
      actualFilter.creditorOrDebtorName = this.cdtrOrDbtrNm
      actualFilter.endToEndId = this.endToEndId
      actualFilter.reason = this.reason
      actualFilter.typeAction = this.typeAction
      actualFilter.user = this.user
      actualFilter.documentType = this.filterDocumentType
      actualFilter.documentName = this.filterDocumentName
      actualFilter.siren = this.filterSiren
      actualFilter.sellerName = this.filterSupplierName
      actualFilter.modeFilter = mode
      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }

      this.$emit('applyFilter', actualFilter.getConditionObject())
    },
    clearFilterFields () {
      let that = this
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }

      if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }
      // Cette partie la fait buguer les filtres et n'envoie rien de l'IHM a la modé
      this.dateBegin = ''
      this.dateEnd = ''
      this.cdtrOrDbtrNm = ''
      this.endToEndId = ''
      this.reason = ''
      this.typeAction = ''
      this.user = ''
      this.filterDocumentType = ''
      this.filterDocumentName = ''
      this.filterSiren = ''
      this.filterSupplierName = ''
      this.filterSupplierId = ''
      this.communicateChange()
    },
    deleteFilter () {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter({})
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter({})
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter({})
          break
        case 'list':
          actualService.filter.saveDefaultFilter({})
          break
        default:
          actualService.filter.saveDefaultFilter({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveDefaultFilter () {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        cdtrOrDbtrNm: this.cdtrOrDbtrNm,
        endToEndId: this.endToEndId,
        reason: this.reason,
        typeAction: this.typeAction,
        user: this.user,
        filterDocumentType: this.filterDocumentType,
        filterDocumentName: this.filterDocumentName,
        filterSiren: this.filterSiren,
        filterSupplierName: this.filterSupplierName,
        filterSupplierId: this.filterSupplierId
      }

      for (const property in this.statusList) {
        let status = that.statusList[property]
        defaultFilter[property] = status.state
      }

      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter(defaultFilter)
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter(defaultFilter)
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter(defaultFilter)
          break
        case 'list':
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getActualService () {
      if (this.isHistory) {
        return this.$engine.history
      } else if (this.isVerifications) {
        return this.$engine.verifications
      } else if (this.isOcr) {
        return this.$engine.ocr
      }
      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments,
        '7': this.$engine.services.businessDocuments,
        '8': this.$engine.services.suppliers
      }

      return serviceName[this.$engine.user.currentService.id]
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== 'modeFilter') {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    showFilterDateBegin () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterDateEnd () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterContactName () {
      if (((this.filterType === 'list' && this.serviceId !== '7' && this.serviceId !== '8') ||
          (this.filterType === 'details' && (this.serviceId === '7' || this.serviceId === '8') && this.mode !== 2) ||
          this.filterType === 'draft') &&
          !this.isHistory && !this.isVerifications && !this.isOcr) {
        return true
      }
      return false
    },
    showFilterDocname () {
      return this.isOcr
    },
    showFilterDoctype () {
      return (this.mode === 2 &&
        this.serviceId === services.DOCUMENTSERVICE) || this.isOcr
    },
    showFilterEndToEndId () {
      return this.isHistory
    },
    showFilterReason () {
      return this.$engine.user.currentService.id !== '7' &&
        this.$engine.user.currentService.id !== '8' &&
        !this.isHistory && !this.isVerifications && !this.isOcr
    },
    showFilterStatus () {
      return this.mode !== 2 &&
        !this.isHistory && !this.isOcr
    },
    showFilterSupplierId () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterSupplierName () {
      if ((this.filterType === 'list' && this.serviceId === services.SUPPLIERS) ||
        (this.filterType === 'details' && this.serviceId === services.DOCUMENTSERVICE && this.mode === 2)) {
        return true
      }
      return false
    },
    showFilterSupplierSIREN () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showListDraftPanel () {
      return this.serviceId === services.DIRECTPAYMENTS
    },
    showListGroupPanel () {
      return this.serviceId === services.PAYMENTS &&
        !this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.user.currentService.id) &&
        status.filterName === this.filterTypeGet
    }
  },
  watch: {
    hasDefaultFilter () {
      this.communicateChange()
    },
    dateBegin () {
      this.communicateChange()
    },
    dateEnd () {
      this.communicateChange()
    },
    cdtrOrDbtrNm () {
      this.communicateChange()
    },
    endToEndId () {
      this.communicateChange()
    },
    reason () {
      this.communicateChange()
    },
    typeAction () {
      this.communicateChange()
    },
    user () {
      this.communicateChange()
    },
    filterDocumentType () {
      this.communicateChange()
    },
    filterDocumentName () {
      this.communicateChange()
    },
    filterSiren () {
      this.communicateChange()
    },
    filterSupplierName () {
      this.communicateChange()
    },
    filterSupplierId () {
      this.communicateChange()
    },
    statusList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  }
}
</script>

<style scoped>
.filterType .label {
  width: 40%;
}
.icon-status-label {
  width: 22px;
  height: 22px;
  background-size: contain;
  margin-top: -4px;
  /* vertical-align: baseline !important; */
}

.list-block .item-title.label {
  width: auto;
}

::-webkit-input-placeholder {
  color: #A7A7A7;
}

label {
  margin-bottom: 0%;
}

.filter {
  width: 100%;
  border-radius: 0px;
  margin: 0px;
}

.filter-item-title {
  color: var(--actionButtonColor);
  font-weight: 700;
}
.filter-item-content {
  color: #969696;
}
.filter-item-section {
  background-color: #f2f2f2;
}
.filter-item {
  display: inline-flex;
  flex-direction: column;
  padding-right: 2rem;
  flex: 1 1 auto;
}
input.filter-item-input, textarea.filter-item-input {
  height:auto;
  line-height:inherit;
  color:inherit;
  font-size:inherit;
}
input.filter-item-input-complete, span.filter-item-input-complete, textarea.filter-item-input-complete {
  color:#000;
}
textarea {
  max-height: 2.5em;
  line-height: inherit;
  padding: 0 0 0 0;
}
.filter-selection {
  z-index:150;
}

.icon {
  min-height: 20px;
  min-width: 20px;
}

i.icon.fa.fa-filter {
  line-height: inherit;
  font-size: 1.3em;
  padding-right: 15px;
}

#status-chevron {
  font-size: inherit;
  line-height: inherit;
  color:inherit;
}

.row {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?d7cde6f2